module.exports = __webpack_public_path__ + "static/media/icon3.ffae6c63.svg";